import React from 'react';

/**
 * Skeleton loading component
 * @param {string} className - Additional classes (width, height, rounding)
 * @param {boolean} isDarkMode - Dark mode state
 */
const Skeleton = ({ className, isDarkMode }) => {
    return (
        <div
            className={`
                animate-pulse 
                ${isDarkMode ? 'bg-slate-700/50' : 'bg-slate-200'} 
                ${className || ''}
            `}
        />
    );
};

export default Skeleton;
